export default __webpack_public_path__ + "static/media/title_vi_pc@2x.a08e11ad.png";